/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable dot-notation */
import React from 'react';
import ImageUploading from 'react-images-uploading';
import { XIcon, RefreshIcon } from '@heroicons/react/solid';
import { BiSolidFile } from 'react-icons/bi';

export const ImageUpload = ({ images, id, onChange, multiple, isNotImage }) => {
  const renderImageIcon = () => {
    return (
      <svg
        className="mx-auto h-12 w-12 text-gray-400"
        stroke="currentColor"
        fill="none"
        viewBox="0 0 48 48"
        aria-hidden="true"
      >
        <path
          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  const renderUploadText = (onImageUpload) => {
    return (
      <>
        <div className="flex text-sm text-gray-600">
          <label
            htmlFor={`file-upload${id ? `-${id}` : ''}`}
            className="relative cursor-pointer bg-white rounded-md "
          >
            <span className="font-medium text-indigo-600 hover:text-indigo-500
              focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
            >
              {multiple ? 'Upload files' : 'Upload a file'}
            </span>
            <input
              id={`file-upload${id ? `-${id}` : ''}`}
              name={`file-upload${id ? `-${id}` : ''}`}
              type="file"
              className="sr-only"
              onClick={(e) => {
                e.preventDefault();
                onImageUpload();
              }}
            />
            <span className="pl-1">or drag and drop</span>
          </label>
        </div>
        <p className="text-xs text-gray-500">Up to 10MB</p>
      </>
    );
  };

  return (
    <ImageUploading
      multiple={multiple}
      value={images}
      onChange={onChange}
      maxNumber={multiple ? 20 : 1}
      dataURLKey="data_url"
      allowNonImageType={!!isNotImage}
    >
      {({
        imageList,
        onImageUpload,
        onImageUpdate,
        onImageRemove,
        isDragging,
        dragProps,
      }) => (
        <>
          <div />
          {!imageList ||
            (imageList.length === 0 && (
              <div
                className={`mt-1 border-2 border-dashed rounded-md px-6 pt-5 pb-6 flex justify-center
                ${isDragging ? 'border-red-500' : 'border-gray-300'}`}
                {...dragProps}
              >
                <div className="text-center">
                  {renderImageIcon()}
                  {renderUploadText(onImageUpload)}
                </div>
              </div>
            ))}
          {imageList &&
            (imageList.length > 0 && (
              <div
                className={`mt-1 border-2 border-dashed rounded-md px-6 pt-5 pb-6 flex w-full
                ${isDragging ? 'border-red-500' : 'border-gray-300'}`}
                {...dragProps}
              >
                <div className="grid gap-6 grid-cols-[repeat(auto-fit,minmax(100px,max-content))] auto-rows-fr w-full">
                  {imageList.map((image, index) => (
                    <div key={index} className={`relative ${index !== imageList.length - 1 ? '' : ''}`}>
                      {!isNotImage && <img className="max-h-40" src={image['data_url']} alt="" />}
                      {!!isNotImage && (
                      <div className="h-24 w-24 border border-gray-300 flex justify-center items-center flex-col border-dashed rounded-md overflow-hidden"><BiSolidFile size={40} className="text-gray-400" />
                        <div className="text-xs mt-2 text-center">{image.file ? image.file.name : 'unknown file'}</div>
                      </div>
                      )}
                      <div className="">
                        <button
                          type="button"
                          onClick={() => onImageRemove(index)}
                          className="absolute -top-2 -right-2 bg-white shadow-md rounded-xl text-center px-1 py-1"
                        >
                          <XIcon className="h-5 w-5 text-red-500" />
                        </button>
                        <button
                          type="button"
                          onClick={() => onImageUpdate(index)}
                          className="absolute top-6 -right-2 bg-white shadow-md rounded-xl text-center px-1 py-1"
                        >
                          <RefreshIcon className="h-5 w-5 text-indigo-500" />
                        </button>

                      </div>
                    </div>
                  ))}
                  {!!multiple && (
                  <div className="text-center flex items-center justify-center flex-col border-2 border-dashed px-1 py-1">
                    {renderImageIcon()}
                    {renderUploadText(onImageUpload)}
                  </div>
                  )}
                </div>
              </div>
            ))}
        </>
      )}
    </ImageUploading>
  );
};
